export default __webpack_public_path__ + "static/media/logo.636ce85f.png";